module.exports = __webpack_public_path__ + "media/flags/np-aec553b1.svg";